import type { InternalAxiosRequestConfig } from "axios";

import { AVAILABLE_LANGUAGE } from "@/shared/models";
import { useSettingsStore } from "@/shared/stores";

export const languageInterceptor = (config: InternalAxiosRequestConfig) => {
  const language = useSettingsStore.getState().language;

  config.headers.set(
    "Accept-Language",
    language === AVAILABLE_LANGUAGE.ES
      ? AVAILABLE_LANGUAGE.ES
      : AVAILABLE_LANGUAGE.EN,
  );

  return config;
};
